

































import Vue from 'vue'
import { Component } from 'vue-property-decorator'

import { createSession } from '@/services/session.service'

declare const config: any

@Component
export default class ErrorComponent extends Vue {
    lang = 'EN'
    docLink = ''
    displayExpirationToken = false
    sessionId = sessionStorage.getItem('session_id') || ''
    invite = {
        invite: ''
    }

    created() {
        sessionStorage.removeItem('currentStep')
        sessionStorage.removeItem('result')
        sessionStorage.removeItem('start')
        sessionStorage.removeItem('end')
        if (this.$route.query.error === 'tokenExpired') {
            this.displayExpirationToken = true
        }

        const storedLang = sessionStorage.getItem('userLang')
        if (storedLang !== null) this.lang = storedLang.toUpperCase()

        if (this.lang === 'FR') {
            this.docLink = config.FR_DOC
        } else {
            this.docLink = config.EN_DOC
        }
    }

    startAgain() {
        this.invite = { invite: this.sessionId }

        createSession(this.sessionId)
            .then((res: any) => {
                this.createSessionSuccess(res.data)
            })
            .catch((err: any) => {
                this.$router.push({ name: 'Error' })
            })
    }

    createSessionSuccess(res: any) {
        sessionStorage.setItem('id', res.id)
        sessionStorage.setItem('brand', JSON.stringify(res.brand))
        sessionStorage.setItem('steps', JSON.stringify(res.steps))
        sessionStorage.setItem('lang', res.lang)

        sessionStorage.setItem('start', JSON.stringify(new Date()))
        this.$router.push({ name: 'Training' })
    }
}

